import { RootDispatch, RootState, Thunk } from 'store/types';
import { Action } from 'modules/types/common';
import Config from 'react-native-config';

import { KEY } from '../types';
import * as types from './types.web';
import { speedPassSelector } from '../activeConsumer/speedPass/selectors';

export const CREATE_VISIT = `${KEY}.CREATE_VISIT`;
export const CREATE_VISIT_SUCCESS = `${KEY}.CREATE_VISIT_SUCCESS`;
export const CREATE_VISIT_FAIL = `${KEY}.CREATE_VISIT_FAIL`;

export const createVisit = () => ({
  type: CREATE_VISIT,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'createVisit'
    }
  }
});

export const UPDATE_COUPON_CODE = `${KEY}.UPDATE_COUPON_CODE`;
export const UPDATE_COUPON_CODE_SUCCESS = `${KEY}.UPDATE_COUPON_CODE_SUCCESS`;
export const UPDATE_COUPON_CODE_FAIL = `${KEY}.UPDATE_COUPON_CODE_FAIL`;

export const updateCouponCode = (payload: types.UpdateCouponCodePayload) => ({
  type: UPDATE_COUPON_CODE,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'updateCouponCode',
      data: payload
    }
  }
});

export const START_VISIT = `${KEY}.START_VISIT`;
export const START_VISIT_SUCCESS = `${KEY}.START_VISIT_SUCCESS`;
export const START_VISIT_FAIL = `${KEY}.START_VISIT_FAIL`;

export const startVisit = (payload: types.VisitPayload) => ({
  type: START_VISIT,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'startVisit',
      data: payload
    }
  }
});

export const FIND_ACTIVE_VISIT = `${KEY}.FIND_ACTIVE_VISIT`;
export const FIND_ACTIVE_VISIT_SUCCESS = `${KEY}.FIND_ACTIVE_VISIT_SUCCESS`;
export const FIND_ACTIVE_VISIT_FAIL = `${KEY}.FIND_ACTIVE_VISIT_FAIL`;

export const findActiveVisit = () => ({
  type: FIND_ACTIVE_VISIT,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'findActiveVisit'
    }
  }
});

export const GET_TELEHEALTH_VIDEO_URL = `${KEY}.GET_TELEHEALTH_VIDEO_URL`;
export const GET_TELEHEALTH_VIDEO_URL_SUCCESS = `${KEY}.GET_TELEHEALTH_VIDEO_URL_SUCCESS`;
export const GET_TELEHEALTH_VIDEO_URL_FAIL = `${KEY}.GET_TELEHEALTH_VIDEO_URL_FAIL`;

export const getTelehealthVideoInstallUrl = () => ({
  type: GET_TELEHEALTH_VIDEO_URL,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'getTelehealthVideoInstallUrl'
    }
  }
});

export const LAUNCH_TELEHEALTH_VIDEO = `${KEY}.LAUNCH_TELEHEALTH_VIDEO`;
export const LAUNCH_TELEHEALTH_VIDEO_SUCCESS = `${KEY}.LAUNCH_TELEHEALTH_VIDEO_SUCCESS`;
export const LAUNCH_TELEHEALTH_VIDEO_FAIL = `${KEY}.LAUNCH_TELEHEALTH_VIDEO_FAIL`;

export const launchTelehealthVideo = (payload: types.VisitPayload) => ({
  type: LAUNCH_TELEHEALTH_VIDEO,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'launchTelehealthVideo',
      data: payload
    }
  }
});

export const PROCESS_VISIT = `${KEY}.PROCESS_VISIT`;
export const PROCESS_VISIT_SUCCESS = `${KEY}.PROCESS_VISIT_SUCCESS`;
export const PROCESS_VISIT_FAIL = `${KEY}.PROCESS_VISIT_FAIL`;

export const processVisit = (payload: types.VisitPayload) => ({
  type: PROCESS_VISIT,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'processVisit',
      data: payload
    }
  }
});

export const VISIT_EMITTER = `${KEY}.VISIT_EMITTER`;

export const visitEmitter = (payload: types.VisitEmitterPayload) => ({
  type: VISIT_EMITTER,
  payload
});

export const CANCEL_VISIT = `${KEY}.CANCEL_VISIT`;
export const CANCEL_VISIT_SUCCESS = `${KEY}.CANCEL_VISIT_SUCCESS`;
export const CANCEL_VISIT_FAIL = `${KEY}.CANCEL_VISIT_FAIL`;

export const cancelVisit = (payload: types.VisitPayload) => ({
  type: CANCEL_VISIT,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'cancelVisit',
      data: payload
    }
  }
});

export const END_VISIT = `${KEY}.END_VISIT`;
export const END_VISIT_SUCCESS = `${KEY}.END_VISIT_SUCCESS`;
export const END_VISIT_FAIL = `${KEY}.END_VISIT_FAIL`;

export const endVisit = (payload: types.VisitPayload) => ({
  type: END_VISIT,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'endVisit',
      data: payload
    }
  }
});

export const ACCEPT_SUGGESTED_TRANSFER = `${KEY}.ACCEPT_SUGGESTED_TRANSFER`;
export const ACCEPT_SUGGESTED_TRANSFER_SUCCESS = `${KEY}.ACCEPT_SUGGESTED_TRANSFER_SUCCESS`;
export const ACCEPT_SUGGESTED_TRANSFER_FAIL = `${KEY}.ACCEPT_SUGGESTED_TRANSFER_FAIL`;

export const acceptSuggestedTransfer = (payload: types.VisitPayload) => ({
  type: ACCEPT_SUGGESTED_TRANSFER,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'acceptSuggestedTransfer',
      data: payload
    }
  }
});

export const TRANSFER_VISIT = `${KEY}.TRANSFER_VISIT`;
export const TRANSFER_VISIT_SUCCESS = `${KEY}.TRANSFER_VISIT_SUCCESS`;
export const TRANSFER_VISIT_FAIL = `${KEY}.TRANSFER_VISIT_FAIL`;

export const handleTransfer = (payload: types.VisitPayload) => ({
  type: TRANSFER_VISIT,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'handleTransfer',
      data: payload
    }
  }
});

export const GET_VISIT_SUMMARY = `${KEY}.GET_VISIT_SUMMARY`;
export const GET_VISIT_SUMMARY_SUCCESS = `${KEY}.GET_VISIT_SUMMARY_SUCCESS`;
export const GET_VISIT_SUMMARY_FAIL = `${KEY}.GET_VISIT_SUMMARY_FAIL`;

export const getVisitSummary = () => ({
  type: GET_VISIT_SUMMARY,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'getVisitSummary'
    }
  }
});

export const SEND_VISIT_SUMMARY = `${KEY}.SEND_VISIT_SUMMARY`;
export const SEND_VISIT_SUMMARY_SUCCESS = `${KEY}.SEND_VISIT_SUMMARY_SUCCESS`;
export const SEND_VISIT_SUMMARY_FAIL = `${KEY}.SEND_VISIT_SUMMARY_FAIL`;

export const sendVisitSummary = (payload: types.SendVisitSummaryPayload) => ({
  type: SEND_VISIT_SUMMARY,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'sendVisitSummary',
      data: payload
    }
  }
});

export const SETUP_WAITING_ROOM_ALERTS = `${KEY}.SETUP_WAITING_ROOM_ALERTS`;
export const SETUP_WAITING_ROOM_ALERTS_SUCCESS = `${KEY}.SETUP_WAITING_ROOM_ALERTS_SUCCESS`;
export const SETUP_WAITING_ROOM_ALERTS_FAIL = `${KEY}.SETUP_WAITING_ROOM_ALERTS_FAIL`;

export const setupWaitingRoomAlerts = (payload: types.SetupWaitingRoomAlertsPayload) => ({
  type: SETUP_WAITING_ROOM_ALERTS,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'setupWaitingRoomAlerts',
      data: payload
    }
  }
});

export const SUBMIT_VISIT_FEEDBACK = `${KEY}.SUBMIT_VISIT_FEEDBACK`;
export const SUBMIT_VISIT_FEEDBACK_SUCCESS = `${KEY}.SUBMIT_VISIT_FEEDBACK_SUCCESS`;
export const SUBMIT_VISIT_FEEDBACK_FAIL = `${KEY}.SUBMIT_VISIT_FEEDBACK_FAIL`;

export const submitVisitFeedback = (payload: types.SubmitVisitFeedbackPayload) => ({
  type: SUBMIT_VISIT_FEEDBACK,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'submitVisitFeedback',
      data: payload
    }
  }
});

/**
 * This particular action is not tied to the Amwell SDK. It is used to submit the
 * form data when the user wants to be contacted my IHC to give additional feedback
 */
export const SUBMIT_CONTACT_INFO_FOR_FEEDBACK = `${KEY}.SUBMIT_CONTACT_INFO_FOR_FEEDBACK`;
export const SUBMIT_CONTACT_INFO_FOR_FEEDBACK_SUCCESS = `${KEY}.SUBMIT_CONTACT_INFO_FOR_FEEDBACK_SUCCESS`;
export const SUBMIT_CONTACT_INFO_FOR_FEEDBACK_FAIL = `${KEY}.SUBMIT_CONTACT_INFO_FOR_FEEDBACK_FAIL`;

export const submitContactInfoForFeedback = (
  payload: types.SubmitContactInfoForFeedbackPayload
) => ({
  type: SUBMIT_CONTACT_INFO_FOR_FEEDBACK,
  payload: {
    client: 'amwellAuthService',
    request: {
      method: 'POST',
      url: Config.AMWELL_AUTH_SERVICE_URL_SUBMIT_CONTACT_INFO_FOR_FEEDBACK,
      data: payload
    }
  }
});

export const ADD_CHAT_MESSAGE = `${KEY}.ADD_CHAT_MESSAGE`;
export const ADD_CHAT_MESSAGE_SUCCESS = `${KEY}.ADD_CHAT_MESSAGE_SUCCESS`;
export const ADD_CHAT_MESSAGE_FAIL = `${KEY}.ADD_CHAT_MESSAGE_FAIL`;

export const addChatMessage = (payload: types.AddChatMessagePayload) => ({
  type: ADD_CHAT_MESSAGE,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'addChatMessage',
      data: payload
    }
  }
});

export const DECLINE_SUGGESTED_TRANSFER = `${KEY}.DECLINE_SUGGESTED_TRANSFER`;
export const DECLINE_SUGGESTED_TRANSFER_SUCCESS = `${KEY}.DECLINE_SUGGESTED_TRANSFER_SUCCESS`;
export const DECLINE_SUGGESTED_TRANSFER_FAIL = `${KEY}.DECLINE_SUGGESTED_TRANSFER_FAIL`;

export const declineSuggestedTransfer = (payload: types.DeclineSuggestedTransferPayload) => ({
  type: DECLINE_SUGGESTED_TRANSFER,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'declineSuggestedTransfer',
      data: payload
    }
  }
});

export const START_WEB_RTC_VISIT = `${KEY}.START_WEB_RTC_VISIT`;
export const START_WEB_RTC_VISIT_SUCCESS = `${KEY}.START_WEB_RTC_VISIT_SUCCESS`;
export const START_WEB_RTC_VISIT_FAIL = `${KEY}.START_WEB_RTC_VISIT_FAIL`;

export const startWebRTCVisit = (payload: types.StartWebRTCVisitPayload) => ({
  type: START_WEB_RTC_VISIT,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'startWebRTCVisit',
      data: payload
    }
  }
});

export const CREATE_VISIT_FROM_SPEED_PASS = `${KEY}.CREATE_VISIT_FROM_SPEED_PASS`;
export const CREATE_VISIT_FROM_SPEED_PASS_SUCCESS = `${KEY}.CREATE_VISIT_FROM_SPEED_PASS_SUCCESS`;
export const CREATE_VISIT_FROM_SPEED_PASS_FAIL = `${KEY}.CREATE_VISIT_FROM_SPEED_PASS_FAIL`;

export const createVisitFromSpeedPass = (): Thunk<Action> => (
  dispatch: RootDispatch,
  getState: () => RootState
) => {
  const speedPassStore = speedPassSelector(getState());
  return dispatch({
    type: CREATE_VISIT_FROM_SPEED_PASS,
    payload: {
      client: 'amwell',
      request: {
        resourceName: 'createVisitFromSpeedPass',
        data: { speedPass: speedPassStore }
      }
    }
  });
};
